<template>
  <div
    :class="[
      organism.containerWidth ? 'container-' + organism.containerWidth : '',
      organism.removeMargin,
      'px-4 organism image xl:px-0',
    ]"
  >
    <div v-if="organism.link1">
      <NuxtLink :href="organism.link1" class="hover:opacity-80">
        <img class="mx-auto" v-bind="imageAttrs" />
      </NuxtLink>
    </div>
    <div v-else>
      <img v-bind="imageAttrs" />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  organism: Object,
});

// Use responsive image composable for performance optimization
// This organism spans its container (1280px max, or the viewport when
// full-width), not the default 33vw, so the browser must request a wide enough file
const imageAttrs = computed(() =>
  useResponsiveImage(
    props.organism.image,
    null,
    props.organism.containerWidth === "full-width"
      ? "100vw"
      : "(max-width: 1280px) 100vw, 1280px"
  )
);

onMounted(() => {
  if (props.organism.containerWidth === "full-width") {
    addFullWidthSupport();
  }
});
</script>
